import { render, staticRenderFns } from "./SnoozeTask.vue?vue&type=template&id=2c27ade6&scoped=true&"
import script from "./SnoozeTask.vue?vue&type=script&lang=ts&"
export * from "./SnoozeTask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c27ade6",
  null
  
)

export default component.exports